import FileComponent from './FileComponent'

export default FileComponent
